import { render, staticRenderFns } from "./NewExtension.vue?vue&type=template&id=325926b1&scoped=true&lang=pug&"
import script from "./NewExtension.vue?vue&type=script&lang=ts&"
export * from "./NewExtension.vue?vue&type=script&lang=ts&"
import style0 from "./NewExtension.vue?vue&type=style&index=0&id=325926b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325926b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
